import React from 'react';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Chip from '@material-ui/core/Chip';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import { useFormikValidateContract } from './pre-ex6.service';
import styles from './pre-ex6.module.css';

const ValidateContract = ({ row }) => {
	let { formik, labels } = useFormikValidateContract(row);
	document.title = `Contract Management - ${row.title} (${row.markingTeamCode})`;

	return (
		<form noValidate onSubmit={formik.handleSubmit}>
			<div className={styles.validate_contract_root}>
				<CardHeader 
					title={
						<Typography noWrap component="h2">
							{'Validate Contract'}
						</Typography>
					}
				>
				</CardHeader>
				<CardContent>
					{Object.keys(labels).map((key, i) => {
						return (
							<FormGroup key={i} row>
								<FormControlLabel
									control={
										<Checkbox
											required
											name={key}
											checked={formik.values[key]}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											disabled={row.isValidatedPreEx6}
										/>
									}
									label={labels[key]}
								/>
								{formik.touched[key] && formik.errors[key] ? (
									<Chip
										style={{
											backgroundColor: 'red',
											color: 'white'
										}}
										variant="default"
										size="small"
										icon={<ErrorOutlineIcon />}
										label={formik.errors[key]}
									/>
								) : null}
							</FormGroup>
						);
					})}
				</CardContent>
				<CardActions className={styles.validation_actions}>
					<Button variant="contained" color="primary" type="submit" disabled={formik.isSubmitting || row.isValidatedPreEx6}>
						Valid
					</Button>
				</CardActions>
			</div>
		</form>
	);
};

export default ValidateContract;
